export var BlockCategory;
(function (BlockCategory) {
    BlockCategory["Start"] = "Start";
    BlockCategory["Logic"] = "Logic";
    BlockCategory["Data"] = "Data";
    BlockCategory["Experience"] = "Experience";
    BlockCategory["Integration"] = "Integration";
    BlockCategory["Ai"] = "Ai";
    BlockCategory["Export"] = "Export";
    BlockCategory["Skill"] = "Skill";
    BlockCategory["Obsolete"] = "Obsolete";
    BlockCategory["Placeholder"] = "Placeholder";
})(BlockCategory || (BlockCategory = {}));
/**
 * BlockSafetyLevel refers to whether a block performs any actions that may make it unsafe to run
 * with actual patient data during a test run. For example, if a block sends an SMS text message,
 * it must be marked "Unsafe" since if the block is run with actual patient data, it would send
 * a message to an actual patient during a test run (undesired behavior).
 * While this property is currently unused, it is a reasonable property of the blockType.
 */
export var BlockSafetyLevel;
(function (BlockSafetyLevel) {
    BlockSafetyLevel["Safe"] = "Safe";
    BlockSafetyLevel["Unsafe"] = "Unsafe";
})(BlockSafetyLevel || (BlockSafetyLevel = {}));
/**
 * This variant is restricted to very specific use cases.
 * You must get approval from design before adding to this list.
 */
export var BlockCustomIconVariant;
(function (BlockCustomIconVariant) {
    BlockCustomIconVariant["Iterator"] = "Iterator";
    BlockCustomIconVariant["SubFlow"] = "SubFlow";
    BlockCustomIconVariant["Script"] = "Script";
    BlockCustomIconVariant["Text"] = "Text";
})(BlockCustomIconVariant || (BlockCustomIconVariant = {}));
export var BlockLifeCycle;
(function (BlockLifeCycle) {
    BlockLifeCycle["Internal"] = "Internal";
    BlockLifeCycle["Published"] = "Published";
    BlockLifeCycle["Beta"] = "Beta";
    BlockLifeCycle["Developer"] = "Developer";
    BlockLifeCycle["Retired"] = "Retired";
    BlockLifeCycle["Obsolete"] = "Obsolete";
})(BlockLifeCycle || (BlockLifeCycle = {}));
//# sourceMappingURL=attributes.js.map